import React, { useEffect, useState } from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import InputField from '../component/InputField'
import PrimaryGradientButton from '../component/PrimaryGradientButton'
import SelectDropDown from '../component/SelectDropDown'
import LeadService from '../services/Lead'
import Loader from '../component/Loader'
import Form from 'react-bootstrap/Form';
import AlertMsg from '../component/AlertMsg';

const LeadRegistration = () => {
    const [loading, setLoading] = useState(true);
    const [customerTypeValidationError, setCustomerTypeValidationError] = useState('')
    const [nameValidationError, setNameValidationError] = useState('')
    const [emailValidationError, setEmailValidationError] = useState('')
    const [addressOneValidationError, setAddressOneValidationError] = useState('')
    const [addressTwoValidationError, setAddressTwoValidationError] = useState('')
    const [postalCodeValidationError, setPostalCodeValidationError] = useState('')
    const [cityValidationError, setCityValidationError] = useState('')
    const [stateValidationError, setStateValidationError] = useState('')
    const [remarkValidationError, setRemarkValidationError] = useState('')
    const [mobileValidationError, setMobileValidationError] = useState('')
    const [productValidationError, setProductValidationError] = useState('')
    const [productQuantityValidationError, setProductQuantityValidationError] = useState('')
    const [siteNameValidationError, setSiteNameValidationError] = useState('')
    const [isProductList, setIsProductList] = useState([])
    const [isProduct, setIsProduct] = useState('')
    const [isCustomer, setIsCustomer] = useState('')
    const [isCityList, setIsCityList] = useState([])
    const [isCity, setIsCity] = useState('')
    const [isStateList, setIsStateList] = useState([])
    const [isState, setIsState] = useState('')
    const [isLoginSuccess, setIsLoginSuccess] = useState({ isLogin: true, heading: '', text: '' })
    const [showAlert, setShowAlert] = useState(false);
    const [isLead, setIsLead] = useState(
        {
            name: '',
            mobile: '',
            email: '',
            addressLineOne: '',
            addressLineTwo: '',
            assign: { id: '', title: '' },
            postalCode: '',
            remarks: '',
            siteName: '',
            productQuantity: ''

        }
    )
    //CityState
    useEffect(() => {
        const CityStateFetchData = async () => {
            if (isLead.postalCode) {
                try {
                    const pin = isLead.postalCode;
                    const token = localStorage.getItem('access_token');
                    const CityStateFetchDataResponse = await LeadService.getCityStatebyPin(pin, token);

                    if (!CityStateFetchDataResponse.error) {
                        const cityStateDataList = CityStateFetchDataResponse.data?.map(item => ({
                            cityName: item.city_name,
                            cityId: item.id,
                            stateName: item.state_name,
                            stateId: item.cog_states_id
                        }));
                        if (cityStateDataList) {
                            const cities = cityStateDataList?.map((item, key) => ({
                                id: item.cityId,
                                title: item.cityName
                            }))
                            
                            const states = cityStateDataList?.map((item, key) => ({
                                id: item.stateId,
                                title: item.stateName
                            }))
                            
                            setIsCityList(cities);
                            setIsStateList(states);
                        }
                    }
                    setLoading(false)
                } catch (error) {
                    console.error("Error fetching City State List:");
                }
            }
        }

        CityStateFetchData();

    }, [isLead.postalCode]);
    //Assignee
    useEffect(() => {
        const assigneeFetchData = async () => {
            try {
                const token = localStorage.getItem('access_token');
                const assigneeFetchDataResponse = await LeadService.assignToList(token);
                if (!assigneeFetchDataResponse.error) {
                    const { "TSO_id": id, "TSO Name": title } = assigneeFetchDataResponse.data;
                    setIsLead(prevState => ({
                        ...prevState,
                        assign: { id, title }
                    }));
                }
                setLoading(false)
            }

            catch (error) {
                console.error("Assignee Data")
            }

        }
        assigneeFetchData()
    }, [])
    //Product
    useEffect(() => {
        const ProductFetch = async () => {
            try {
                const token = localStorage.getItem('access_token');
                const productFetchResponse = await LeadService.getProducts(token);
                if (!productFetchResponse.error) {
                    const ProductListing = productFetchResponse.data.ProductDetails.map((item) => {
                        return {
                            id: item.id,
                            title: item.product_name
                        }
                    })
                    setIsProductList(ProductListing)
                }
                setLoading(false)
            }
            catch (error) {
                console.error("Product Error")
            }
        }
        ProductFetch()
    }, [])
    const customerType = [
        {
            id: 'BNI',
            title: 'BNI',
        },
        {
            id: 'INH',
            title: 'INH',
        },
        {
            id: 'Non-Trade',
            title: 'Non-Trade',
        },
    ];
    const handleCustomerChange = (selectedValue) => {
        setIsCustomer(selectedValue)
    }
    const handleCityChange = (selectedValue) => {
        setIsCity(selectedValue)
    }
    const handleStateChange = (selectedValue) => {
        setIsState(selectedValue)
    }
    const handleLeadRegistrationInputs = (e) => {
        let value = e.target.value;
        if (e.target.name === 'mobile' || e.target.name === 'postalCode') {
            // Remove non-numeric characters
            value = value.replace(/\D/g, '');
        }
        setIsLead({ ...isLead, [e.target.name]: value })
        switch (e.target.name) {
            case 'name':
                setNameValidationError('');
                break;
            case 'mobile':
                setMobileValidationError('');
                break;
            case 'email':
                setEmailValidationError('');
                break;
            case 'addressLineOne':
                setAddressOneValidationError('');
                break;
            case 'addressLineTwo':
                setAddressTwoValidationError('');
                break;
            case 'postalCode':
                setPostalCodeValidationError('');
                break;
            case 'remarks':
                setRemarkValidationError('');
                break;
            case 'siteName':
                setSiteNameValidationError('');
                break;
            case 'productQuantity':
                setProductQuantityValidationError('')
        }

    }
    const handleProductChange = (selectedValue) => {
        setIsProduct(selectedValue)
    }
    const handleLeadRegistrationSubmit = async () => {
        const validations = [

            { value: isCustomer, setter: setCustomerTypeValidationError, message: 'Customer Type is required' },
            { value: isLead.name, setter: setNameValidationError, message: 'Name is required' },
            { value: isLead.mobile, setter: setMobileValidationError, message: 'Mobile No is required' },
            { value: isLead.email, setter: setEmailValidationError, message: 'Email is required' },
            { value: isLead.addressLineOne, setter: setAddressOneValidationError, message: 'Address Line1 is required' },
            { value: isLead.addressLineTwo, setter: setAddressTwoValidationError, message: 'Address Line2 is required' },
            { value: isLead.postalCode, setter: setPostalCodeValidationError, message: 'Postal Code is required' },
            { value: isState, setter: setStateValidationError, message: 'State is required' },
            { value: isCity.id, setter: setCityValidationError, message: 'City is required' },
            { value: isProduct, setter: setProductValidationError, message: 'Product Name is required' },
            { value: isProduct, setter: setProductValidationError, message: 'Product Name is required' },
            { value: isLead.productQuantity, setter: setProductQuantityValidationError, message: 'Product Quantity is required' },
            { value: isLead.siteName, setter: setSiteNameValidationError, message: 'Site Name is required' },
            { value: isLead.remarks, setter: setRemarkValidationError, message: 'Remarks is required' }

        ]
        validations.forEach(({ value, setter, message }) => {
            if (!value) {
                setter(message);
            }
            else {
                setter(''); // Clear the error message
            }
        });

        try {
            const token = localStorage.getItem('access_token');
            let payload;
            switch (isCustomer.id) {
                case 'BNI':
                    payload = {
                        customerType: isCustomer.id,
                        name: isLead.name,
                        mobileNumber: isLead.mobile,
                        email: isLead.email,
                        addressLine1: isLead.addressLineOne,
                        addressLine2: isLead.addressLineTwo,
                        assignTo: parseInt(isLead.assign.id),
                        hierarchyId: 20,
                        postCode: isLead.postalCode,
                        statesId: parseInt(isState.id),
                        citiesId: parseInt(isCity.id),
                        remarks: isLead.remarks
                    }

                    break;
                case 'Non-Trade':
                    payload = {
                        customerType: isCustomer.id,
                        name: isLead.name,
                        mobileNumber: isLead.mobile,
                        email: isLead.email,
                        addressLine1: isLead.addressLineOne,
                        addressLine2: isLead.addressLineTwo,
                        assignTo: parseInt(isLead.assign.id),
                        hierarchyId: 20,
                        postCode: isLead.postalCode,
                        statesId: parseInt(isState.id),
                        citiesId: parseInt(isCity.id),
                        remarks: isLead.remarks,
                        siteName: isLead.siteName,
                        products: [
                            { product_master_id: isProduct.id, quantity: parseInt(isLead.productQuantity) },
                        ],

                    }
                    break;
            }
            const res = await LeadService.createLead(payload, token);
            if(!res.error){
                setShowAlert(true)
                setIsLoginSuccess({ isLogin: true, text: res.data.message }) 
            }
            else{
                setShowAlert(true)
                setIsLoginSuccess({ isLogin: false, text: res.data.message })
            }
        }
        catch (error) {
            console.error('Error submitting lead registration:');
             
        }
    }
    return (
        <>
            {loading && <Loader />}
            <section className='padTop50'>
                <Container>
                    <Row className='justify-content-center align-item-center h-100'>
                        <Col>
                            <div className='userInfoBox'>
                                <div className='dashboard-title'>
                                    <h4>Please Register Your Lead</h4>
                                </div>
                                <div className="dashboard-details middleWrapSelect">
                                    <Row>
                                        <Col xs={12} lg={3}>
                                            <SelectDropDown
                                                labelName="Customer Type"
                                                requiredStar='*'
                                                options={customerType}
                                                setSelectedValue={setIsCustomer}
                                                selectedValue={isCustomer}
                                                onChange={handleCustomerChange} />
                                            {customerTypeValidationError && (
                                                <div className="error-message">{customerTypeValidationError}</div>
                                            )
                                            }
                                        </Col>

                                        <Col xs={12} lg={3}>
                                            <InputField
                                                inputFieldLabel="Name"
                                                requiredStar='*'
                                                name="name"
                                                value={isLead.name}
                                                onChange={handleLeadRegistrationInputs} />
                                            {nameValidationError && (
                                                <div className="error-message">{nameValidationError}</div>
                                            )
                                            }

                                        </Col>
                                        <Col xs={12} lg={3}>
                                            <Form.Label>Mobile No<span className='redStar'>*</span></Form.Label>
                                            <Form.Control
                                                type="tel"
                                               name="mobile"
                                                value={isLead.mobile}
                                                 onChange={handleLeadRegistrationInputs} 
                                           />
                                            {/* <InputField
                                                inputFieldLabel="Mobile No"
                                                pattern="[0-9]{10}"
                                                requiredStar='*'
                                                name="mobile"
                                                value={isLead.mobile}
                                                onChange={handleLeadRegistrationInputs} /> */}
                                            {mobileValidationError && (
                                                <div className="error-message">{mobileValidationError}</div>
                                            )
                                            }
                                        </Col>
                                        <Col xs={12} lg={3}>
                                            <InputField
                                                inputFieldLabel="Email"
                                                requiredStar='*'
                                                name="email"
                                                value={isLead.email}
                                                onChange={handleLeadRegistrationInputs} />
                                            {emailValidationError && (
                                                <div className="error-message">{emailValidationError}</div>
                                            )
                                            }
                                        </Col>
                                        <Col xs={12} lg={3}>
                                            <InputField
                                                inputFieldLabel="Address Line 1"
                                                requiredStar='*'
                                                name="addressLineOne"
                                                value={isLead.addressLineOne}
                                                onChange={handleLeadRegistrationInputs} />
                                            {addressOneValidationError && (
                                                <div className="error-message">{addressOneValidationError}</div>
                                            )
                                            }
                                        </Col>
                                        <Col xs={12} lg={3}>
                                            <InputField
                                                inputFieldLabel="Address Line 2"
                                                requiredStar='*'
                                                name="addressLineTwo"
                                                value={isLead.addressLineTwo}
                                                onChange={handleLeadRegistrationInputs} />
                                            {addressTwoValidationError && (
                                                <div className="error-message">{addressTwoValidationError}</div>
                                            )
                                            }
                                        </Col>
                                        <Col xs={12} lg={3}>
                                            <InputField
                                                inputFieldLabel="Assign To"
                                                requiredStar='*'
                                                name="assign"
                                                value={isLead.assign.title}
                                                onChange={handleLeadRegistrationInputs} />

                                        </Col>
                                        <Col xs={12} lg={3}>
                                            <InputField
                                                inputFieldLabel="Postal Code"
                                                requiredStar='*'
                                                name="postalCode"
                                                value={isLead.postalCode}
                                                onChange={handleLeadRegistrationInputs} />
                                            {postalCodeValidationError && (
                                                <div className="error-message">{postalCodeValidationError}</div>
                                            )
                                            }
                                        </Col>
                                        <Col xs={12} lg={3} className='mt-2'>
                                            <SelectDropDown
                                                labelName="City"
                                                requiredStar='*'
                                                options={isCityList}
                                                setSelectedValue={setIsCity}
                                                selectedValue={isCity}
                                                onChange={handleCityChange} />
                                            {cityValidationError && (
                                                <div className="error-message">{cityValidationError}</div>
                                            )
                                            }
                                        </Col>
                                        <Col xs={12} lg={3} className='mt-2'>
                                            <SelectDropDown
                                                labelName="State"
                                                requiredStar='*'
                                                options={isStateList}
                                                setSelectedValue={setIsState}
                                                selectedValue={isState}
                                                onChange={handleStateChange} />
                                            {stateValidationError && (
                                                <div className="error-message">{stateValidationError}</div>
                                            )
                                            }
                                        </Col>
                                        {isCustomer && isCustomer.id == 'Non-Trade' && (
                                            <>
                                                <Col xs={12} lg={3}>
                                                    <SelectDropDown
                                                        labelName="Product"
                                                        requiredStar='*'
                                                        options={isProductList}
                                                        setSelectedValue={setIsProduct}
                                                        selectedValue={isProduct}
                                                        onChange={handleProductChange} />
                                                    {productValidationError && (
                                                        <div className="error-message">{productValidationError}</div>
                                                    )
                                                    }
                                                </Col>
                                                <Col xs={12} lg={3}>
                                                    <InputField
                                                        inputFieldLabel="Product Quantity"
                                                        requiredStar='*'
                                                        name="productQuantity"
                                                        value={isLead.productQuantity}
                                                        onChange={handleLeadRegistrationInputs} />
                                                    {productQuantityValidationError && (
                                                        <div className="error-message">{productQuantityValidationError}</div>
                                                    )
                                                    }

                                                </Col>
                                                <Col xs={12} lg={3}>
                                                    <InputField
                                                        inputFieldLabel="Site Name"
                                                        requiredStar='*'
                                                        name="siteName"
                                                        value={isLead.siteName}
                                                        onChange={handleLeadRegistrationInputs} />
                                                    {siteNameValidationError && (
                                                        <div className="error-message">{siteNameValidationError}</div>
                                                    )
                                                    }
                                                </Col>
                                            </>
                                        )}
                                        <Col xs={12} lg={3} className='mt-2'>
                                            <InputField
                                                inputFieldLabel="Remarks"
                                                requiredStar='*'
                                                name="remarks"
                                                value={isLead.remarks}
                                                onChange={handleLeadRegistrationInputs} />
                                            {remarkValidationError && (
                                                <div className="error-message">{remarkValidationError}</div>
                                            )
                                            }
                                        </Col>
                                        <Col xs={12} lg={3} className='mt-33'>
                                            <PrimaryGradientButton
                                                buttonText="Submit" onClick={handleLeadRegistrationSubmit} />
                                        </Col>
                                        <Col xs={12} className='mt-3'>
                                      <div className='alertBoxWrap'>
                                          {showAlert && <AlertMsg alertBoxColor={isLoginSuccess.isLogin ? 'successAlert' : 'FailedAlert'}
                                              heading={isLoginSuccess.heading}
                                              text={isLoginSuccess.text}
                                          />
                                          }
                                          </div>
                                      </Col>
                                    </Row>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>

            </section>
        </>
    )
}

export default LeadRegistration